export default class ScopesEnum {
    static WRITE_MINAPP = "write_miniapp";
    static APPROVE_REVISION = "approve_revision";
    static REJECT_REVISION = "reject_revision";
    static PUBLISH_REVISION = "publish_revision";
    static WRITE_MINIAPP_PROPERTIES = "write_miniapp_properties";
    static DOWNLOAD_SOURCES = "download_sources";
    static WRITE_ROLE = "write_role";
    static VIEW_SECURITY = "view_security";
    static READ_ORGANIZATION = "read_organization";
}
